import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import HomeIcon from "@mui/icons-material/Home";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import DescriptionIcon from "@mui/icons-material/Description";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";

import CustomForm from "../../../helper-components/form/CustomForm";
import NavigationFooter from "../../../helper-components/misc/NavigationFooter";

import TranscriptsTable from "./components/TranscriptsTable";

import { getLanguage } from "../../../config/language/language.js";

/**
 * The transcripts page.
 */
export default function Transcripts(props) {
    return (
        <Container maxWidth="xl" sx={{ mt: 2, mb: 2 }}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <CustomForm title={getLanguage().TRANSCRIPTS_TITLE} subtitle={getLanguage().TRANSCRIPTS_SUBTITLE} icon={<TextFieldsIcon />} />
                </Grid>

                <Grid item xs={12}>
                    <TranscriptsTable {...props} />
                </Grid>

                <NavigationFooter
                    rows={2}
                    options={[
                        {
                            path: `/database/resources`,
                            title: "Resources",
                            variant: "outlined",
                            icon: <DescriptionIcon />
                        },
                        {
                            path: `/database/quotes`,
                            title: "Quotes",
                            variant: "outlined",
                            icon: <FormatQuoteIcon />
                        },
                        {
                            path: `/home`,
                            title: "Home",
                            variant: "outlined",
                            icon: <HomeIcon />
                        }
                    ]}
                />
            </Grid>
        </Container>
    );
}
